import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { isPendingAction, isRejectedAction, isFullfieldAction } from './slice.helper';
import Api from '../../services/facture-fb.service';



export const listFactureFB = createAsyncThunk(
    "FactureFB/adm-list",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewAll(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const viewFactureFB = createAsyncThunk(
    "FactureFB/adm-view",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.view(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createFactureFB = createAsyncThunk(
    "FactureFB/adm-create",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.create(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const validateFactureFB = createAsyncThunk(
    "FactureFB/adm-validate",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.validate(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateFactureFB = createAsyncThunk(
    "FactureFB/adm-update",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.update(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateCmdMultiStatus = createAsyncThunk(
    "FactureFB/adm-update",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateMultiStatus(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)


export const deleteFactureFB = createAsyncThunk(
    "FactureFB/adm-delete",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.remove(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const validateFactureFbEtiq = createAsyncThunk(
    "FactureFB/adm-validateFactureFbEtiq",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.validateEtiquetage(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)






const initialState = {
    loading: false,
    error: '',
    sel_FactureFB: null
}

const FactureFBSlice = createSlice({
    name: "FactureFB",
    initialState: initialState,
    reducers: {
        clear: (state) => {
            Object.assign(state, initialState)
        },
        set_error: (state , action) => {
            state.error = action.payload
        },

    },
    extraReducers: builder => {
        builder
            .addMatcher(isFullfieldAction, (state, action) => {
                state[action.meta.requestId] = 'fulfilled'
                state.loading = false;
                state.error = '';
            })
            .addMatcher(isPendingAction, (state, action) => {
                state[action.meta.requestId] = 'pending'
                state.loading = true;
                state.error = '';
            })
            .addMatcher(isRejectedAction, (state, action) => {
                state[action.meta.requestId] = 'rejected'
                state.loading = false;
                state.error = action.payload;
            })



    }
})

const { reducer } = FactureFBSlice;
export const { clear, set_error } = FactureFBSlice.actions;
export default reducer;